import { render, staticRenderFns } from "./BaseButtonGroup.vue?vue&type=template&id=0ff1ab0e&scoped=true&"
import script from "./BaseButtonGroup.vue?vue&type=script&lang=js&"
export * from "./BaseButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonGroup.vue?vue&type=style&index=0&id=0ff1ab0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff1ab0e",
  null
  
)

export default component.exports